// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"a4c927f8","49":"57f983f2","96":"b3b2084b","101":"53912766","336":"a6a85974","419":"5076c1cc","812":"e091351d","974":"c6796c10"}[chunkId] + ".chunk.js";
};